module.exports = __webpack_public_path__ + "static/media/python.16acf397.svg";